<div id="app"><transition name="fade"><router-view></router-view></transition></div>